export const PAGE_COUNT = 20;
export const CKAN_API_ENDPOINT =
  "https://openbudgetsindia.org/api/3/action/package_search";
export const CKAN_API_VISUALISATION_ENDPOINT =
  "https://openbudgetsindia.org/api/3/action/package_search?q=union-budget-at-a-glance-timeseries";
